import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import './Home.css';

const Home = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className="home-page">
        <div className="welcome-section">
          <h2>Welcome, {user.name || user.username}!</h2>
          <p>You are logged in as <strong>{user.role}</strong></p>
        </div>

        {/* User Roles Section */}
        <div className="info-section">
          <h3>Your Roles</h3>
          <div className="info-content">
            {user.roles && user.roles.length > 0 ? (
              <div className="roles-list">
                {user.roles.map((role) => (
                  <div key={role.id} className="role-badge">
                    <div className="role-name">{role.name}</div>
                    {role.description && (
                      <div className="role-description">{role.description}</div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="legacy-role">
                <div className="role-badge">
                  <div className="role-name">{user.role}</div>
                  <div className="role-description">Legacy role format</div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* User Permissions Section */}
        {user.permissions && user.permissions.length > 0 && (
          <div className="info-section">
            <h3>Your Permissions</h3>
            <div className="info-content">
              <div className="permissions-grid">
                {user.permissions.map((permission) => (
                  <div key={permission.id} className="permission-item">
                    <div className="permission-name">{permission.name}</div>
                    {permission.description && (
                      <div className="permission-description">{permission.description}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="content-placeholder">
          <p>Application content will be added here.</p>
        </div>
    </div>
  );
};

export default Home;
